import Column from '@components/Column';
import Image from '@components/Image';
import styled from '@emotion/styled';
import { MainRecommendedItemRow } from '@models/item/recommendedItem';
import { Link } from '@router/Link';
import { pressActionEffect } from '@styles/mixin';

import RecommendationText from './RecommendationText';

interface Props {
    item: MainRecommendedItemRow;
}

function RecommendationItem({ item }:Props) {
    const { thumbnailUrl } = item;
    return (
        <Link activityName='ShopListActivity'
            activityParams={{
                originalItemId: item.itemId,
                type: 'LIST',
                isOrder: true,
            }}
            css={pressActionEffect}>
            <Container spacing={5} fullWidth>
                <ThumbnailImage src={thumbnailUrl}
                    width={118}
                    height={118}
                    alt='음료' />
                <RecommendationText item={item} />
            </Container>
        </Link>
    );
}

const ThumbnailImage = styled(Image)`
    border-radius: 12px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.10);
    overflow: hidden;
    background-color: white;
    object-fit: cover;
`;

const Container = styled(Column)`
    max-width: 118px;
    min-width: 118px;
`;

export default RecommendationItem;
